const landingPageStructuredData = {
  '@context': 'http://schema.org',
  '@type': 'Dataset',
  name: 'Endurance Exercise Training Young Adult Rats (6 months) Data',
  description:
    'The Molecular Transducers of Physical Activity Consortium (MoTrPAC) aims to elucidate how exercise improves health and ameliorates diseases by building a map of the molecular responses to endurance exercise. MoTrPAC is a multi-site collaboration across the US encompassing various scientific disciplines: preclinical animal study sites and human clinical exercise sites, which perform the exercise testing and biospecimen collection; a consortium coordinating center and biorepository, which manages sample collection, distribution of samples, and consortium logistics; chemical analysis sites, which are responsible for omics analysis from the samples collected; and a bioinformatics center to collaboratively analyze and map the data generated by the other sites along with data dissemination to make the data and other resources available to the public. The animal studies enable analysis of the effects of exercise on many different tissues that are not readily obtainable in humans, whereas the collection of accessible human tissues (muscle, blood, and adipose) will permit the analysis of the direct effect of exercise in humans. Additional information can be found at the main consortium page (https://motrpac.org) or at the data portal (https://motrpac-data.org).',
  sourceOrganization:
    'Molecular Transducers of Physical Activity Consortium (MoTrPAC)',
  url: 'https://motrpac-data.org/',
  keywords: [
    'transcriptomics',
    'protemoics',
    'epigenomics',
    'metablomics',
    'multiomics',
    'blood rna',
    'plasma',
    'hippocampus',
    'cortex',
    'hypothalamus',
    'gastrocnemius',
    'leg skeletal muscle',
    'vastus lateralis',
    'heart',
    'kidney',
    'adrenal',
    'colon',
    'spleen',
    'testes',
    'male gonads',
    'ovaries',
    'female gonads',
    'vena cava',
    'lung',
    'small intestine',
    'liver',
    'brown adipose',
    'ubcutaneous white adipose tissue',
    'white adipose',
    'acetylproteomics',
    'protein site acetylation',
    'chromatin accessibility',
    'ATAC-seq data',
    'multiplexed immunoassays (cytokines and hormones)',
    'metabolomics and lipidomics',
    'DNA methylation',
    'RRBS data',
    'phosphoproteomics',
    ' protein site phosphorylation',
    'global proteomics',
    'protein abundance',
    'transcriptomics',
    'RNA-Seq data',
    'ubiquitylome',
    'protein site ubiquitination',
    'HSP',
    'HSP70',
    'HSP90',
    'STAT3',
    'PXN',
    'HGF',
    'AGC',
    'AKT1',
    'SRC',
    'MEF2C',
    'HOMER35',
    'GJA1 pY265',
    'CDH2 pY820',
    'Gja1',
    'Cx43',
    'Cdh2',
    'EGF',
    'IGF',
    'HGF',
    'HDAC4',
    'GLUT4',
    'PPARGC1A',
    'Lep',
    'Mmp2',
    'Apoc3',
    'Leptin',
    'Methallopeptitase 2',
    'Apolipoprotein C-III',
    'ERRg',
    'Dsp',
    'Mylk',
    'Desmoplakin',
    'Myosin light chain kinase',
    'Desmin',
    'Stathmin 1',
    'Nesprin 1',
    'PRKACA',
    'PU.1',
    'IRF8',
    'IRF3',
    'Btk',
    'Cd72',
    'Cd79a',
    'Cd3e',
    'Gata3',
    'Il2rg',
    'Ptpn22',
    'Zap70',
    'Cd5',
    'Card11',
    'Pntp22',
    'MHC class II',
    'RT1-Dob',
    'RT1-Db2',
    'Itgal',
    'Cxcr3',
    'Il1a',
    'Rac2',
    'Ncf1',
    'Ncf4',
    'Cybb',
    'GPI',
    'FBP2',
    'DLAT',
    'Fkbp5',
    'Agap2',
    'Crat',
    'Hsp90aa1',
    'Cx3cl1',
    'Eef2k',
    'Gpnmb',
    'Hsph1',
    'Ndufa12',
    'Snx20',
    'Sparc',
    'Tns1',
    'Tpi1',
  ],
  isAccessibleForFree: true,
  funder: {
    '@type': 'Organization',
    name: 'National Institute of Health (NIH) Common Fund',
  },
  includedInDataCatalog: {
    '@type': 'DataCatalog',
    name: 'nih.gov',
  },
  distribution: [
    {
      '@type': 'DataDownload',
      encodingFormat: 'CSV',
      contentUrl: 'https://motrpac-data.org/',
    },
  ],
};

export default landingPageStructuredData;
